import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  detailedData: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
};

const testingAnalyticsDetailedSlice = createSlice({
  name: "testingAnalyticsDetailed",
  initialState,
  reducers: {
    fetchDetailed: (state, action) => {
      state.loading = true;
      state.error = null;
      state.detailedData = [];
    },
    fetchDetailedSuccess: (state, action) => {
      const { data } = action.payload;
      state.loading = false;
      state.detailedData = Array.isArray(data?.labData) ? data.labData : [];
      state.pagination.total = state.detailedData.length;
    },
    fetchDetailedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.detailedData = [];
      state.pagination.total = 0;
    },
    clearError: (state) => {
      state.error = null;
    },
    setPagination: (state, action) => {
      const { currentPage, pageSize } = action.payload;
      state.pagination.currentPage = currentPage;
      if (pageSize) {
        state.pagination.pageSize = pageSize;
      }
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
      state.pagination.currentPage = 1; // Reset to first page when page size changes
    },
    resetPagination: (state) => {
      state.pagination.currentPage = 1;
      state.pagination.pageSize = 10;
    },
  },
});

export const { actions, reducer } = testingAnalyticsDetailedSlice;
export const sliceKey = testingAnalyticsDetailedSlice.name;